const LOAD_DATA_CAREER_PATHWAY           = 'LOAD_DATA_CAREER_PATHWAY'
const LOAD_DATA_CAREER_PATHWAY_SUCCESS   = 'LOAD_DATA_CAREER_PATHWAY_SUCCESS'
const LOAD_DATA_CAREER_PATHWAY_FAILED    = 'LOAD_DATA_CAREER_PATHWAY_FAILED'
const UNMOUNT_DATA_CAREER_PATHWAY        = 'UNMOUNT_DATA_CAREER_PATHWAY'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const careerPathwayReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_CAREER_PATHWAY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_CAREER_PATHWAY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_CAREER_PATHWAY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_CAREER_PATHWAY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default careerPathwayReducer;